import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, renderSlot as _renderSlot, vModelSelect as _vModelSelect, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f892c908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "vtl-table" }
const _hoisted_3 = { class: "vtl-thead" }
const _hoisted_4 = {
  key: 0,
  class: "vtl-thead vtl-td-checkbox"
}
const _hoisted_5 = ["checked"]
const _hoisted_6 = {
  key: 1,
  class: "vtl-thead vtl-td-checkbox"
}
const _hoisted_7 = ["onClick", "title"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "vtl-loading-content" }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = {
  key: 0,
  class: "vtl-tbody"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "vtl-tbody"
}
const _hoisted_15 = ["value", "checked", "onChange", "disabled"]
const _hoisted_16 = ["title"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "vtl-loading-content" }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = {
  key: 0,
  class: "vtl-empty-msg"
}
const _hoisted_22 = {
  key: 0,
  class: "vtl-paging vtl-row"
}
const _hoisted_23 = { class: "vtl-paging-info col-md-4" }
const _hoisted_24 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}
const _hoisted_25 = { class: "vtl-pagination col-md-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "First", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "<", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Prev", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, ">", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Last", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "vtl-paging-change col-md-4" }
const _hoisted_40 = { class: "vtl-paging-span" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "vtl-paging-span" }
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 1,
  class: "vtl-paging vtl-row"
}
const _hoisted_45 = { class: "vtl-paging-info col-md-4" }
const _hoisted_46 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "vtl-pagination col-md-4" }, null, -1))
const _hoisted_48 = { class: "vtl-paging-change col-md-4" }
const _hoisted_49 = { class: "vtl-paging-span" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "vtl-paging-span" }
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 2,
  class: "vtl-paging vtl-row"
}
const _hoisted_54 = { class: "vtl-paging-info col-md-4" }
const _hoisted_55 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}

import {
    ref,
    Ref,
    computed,
    nextTick,
    ComputedRef,
    onMounted,
    onUnmounted,
    inject,
    watch,
} from "vue";
import CancellablePromise from "@/types/CancellablePromise";
import Sorter from "@/services/SorterService";
import ScrollToTopButton from "@/components/ScrollToTopButton.vue";
import { table } from "console";
// Misc
import log from "loglevel";

export interface ITableProps<T> {
    /**
     *  An array of T typed objects for displaying on the table
     */
    Rows?: Array<T>; //can be updated by parent
    /**
     *  An array containing field names of T, or subarrays
     *   of field names if the cell uses multiple field of data
     *   when sorting, the last element is the most important
     *
     *  example: if T has 'arms': Array<Arm>,'legs': Array<Leg>,'head': Head
     *  you can pass ['arms',['legs','head']]
     */
    Cols: Array<keyof T | Array<keyof T>>;
    /**
     * The column headings you want to show on the table for each column
     * If the length doesn't match that of Cols, will show the field
     * names defined in Cols instead
     */
    Labels?: Array<string>;
    /**
     * The unique key of each row for accessing rows, not important
     * for now actually because Rows isn't implemented as a map at the moment
     */
    ColKey?: string;
    /**
     * Set to sort this column by the order defined by `DefaultSortCols` by default
     * if possible must be an numeric index value
     */
    DefaultSortCols?: Array<number>;
    /**
     * Set to sort the columns in `DefaultSortCols` to ascending (1) or order by
     * descending (-1) order
     */
    DefaultSortOrders?: Array<1 | -1>;
    /**
     * If true, show an extra column of checkboxes to the left
     *
     * Default is true.
     */
    HasCheckBox?: boolean;
    /**
     * If true, it shows the checkbox in the header
     *
     * Default is true.
     */
    checkAll?: boolean;
    /**
     * If true, all rows have checkboxes to the left
     * If false, checkboxed rows are specified in `CheckboxedRows`
     *
     * Default is true.
     */
    CheckBoxForAllRows?: boolean;
    /**
     * If true, all rows have checkboxes to the left
     * If false, checkboxed rows are specified by `CheckboxOnRow`
     *
     * Default is true.
     */
    CheckBoxOnRow?: string;
    /**
     * If true, 'CheckBoxOnRow' defined which rows should should be have checkbooxes
     *
     * Default is false.
     */
    CheckBoxOnRowDefinesNegatives?: boolean;
    // Number of rows per page
    /**
     * Default number of rows per page when the page is displayed.
     * (The user may have a preference saved, pass it here)
     *
     * Default is 20.
     */
    RowsPerPage?: number;
    // data passed in may only be a subset of the total number of records
    /**
     * The total number of records for the current query from the database
     * for calculating number of pages. When data is fully loaded, you
     * can just pass Rows.length. Otherwise pass the number the server returns.
     */
    NumRecords?: number; //can be updated by parent
    //assumes when NumRecords!=Rows.length, needs to be dynamically loaded
    /**
     * Do I return the reference to checked rows or just the keys of those rows
     * If key is not defined, return entire row even if true.
     *
     * Default is false.
     */
    ReturnKey?: boolean;
    /**
     * Array of page numbers to show on the screen for the dropdown box.
     *
     * Default is [20,50,100].
     */
    PageOptions?: Array<number>;
    /**
     * The message displayed on the bottom left corner
     * {0} is the starting row on display, {1} is the last row on display
     * {2} is the current page
     *
     * Default message is Showing {0}-{1} of {2}
     */
    PagingInfoMessage?: string;
    /**
     * The label in front of the dropdown box of page
     *
     * Default is Row count:
     */
    PageSizeChangeLabel?: string;
    GotoPageLabel?: string;
    NoDataAvailableMessage?: string;
    /**
     * If true, hides the table but leaves the headings untouched
     */
    HideTable?: boolean;
    ShowTableCount?: boolean;
    RowClickedCallback?: (row: T) => void;
    UnstyledCheckedRows?: boolean;
    CheckRow?: Function;
    UpdateCheckedRows?: Function;
    CheckedByDefault?: boolean;
    SynchroniseChecks?: Function;
    SynchroniseChecksTrigger?: boolean;
    checkedRows?: (keyof T)[];
    checkCounter?: number;
    ShowExpand?: boolean,
    ExpansionThreshold?: number,
    LoadDataCallBack?: (
        page: number,
        rowsPerPage: number,
        sortCols: Array<number>,
        sortOrders: Array<-1 | 1>
    ) => CancellablePromise<void>;
}
export interface RowWrapper<T> {
    checked: boolean;
    value: T;
}
export interface ITableExportsInternal<T> {
    LoadData: () => void;
    GetChecked: () => T[] | T[keyof T][];
    TableLeft: number | Ref<number>;
    TableRight: number | Ref<number>;
}
const scrollOffset = 50;

export default /*#__PURE__*/_defineComponent({
  __name: 'TableLite',
  props: {
    Rows: {},
    Cols: {},
    Labels: {},
    ColKey: {},
    DefaultSortCols: {},
    DefaultSortOrders: {},
    HasCheckBox: { type: Boolean, default: true },
    checkAll: { type: Boolean, default: true },
    CheckBoxForAllRows: { type: Boolean, default: true },
    CheckBoxOnRow: {},
    CheckBoxOnRowDefinesNegatives: { type: Boolean },
    RowsPerPage: { default: 20 },
    NumRecords: {},
    ReturnKey: { type: Boolean },
    PageOptions: { default: () => [20, 50, 100] },
    PagingInfoMessage: { default: "Showing {0}-{1} of {2}" },
    PageSizeChangeLabel: { default: "Row count: " },
    GotoPageLabel: { default: "Go to page: " },
    NoDataAvailableMessage: { default: "No data" },
    HideTable: { type: Boolean },
    ShowTableCount: { type: Boolean },
    RowClickedCallback: {},
    UnstyledCheckedRows: { type: Boolean },
    CheckRow: {},
    UpdateCheckedRows: {},
    CheckedByDefault: { type: Boolean },
    SynchroniseChecks: {},
    SynchroniseChecksTrigger: { type: Boolean },
    checkedRows: { default: () => [] as (keyof T)[] },
    checkCounter: {},
    ShowExpand: { type: Boolean },
    ExpansionThreshold: { default: 3 },
    LoadDataCallBack: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
let isLoading = ref(true);
let callBackPromise: CancellablePromise<void> | undefined = undefined;
const page: Ref<number> = inject("page") ?? ref(1);
const numRecords = computed(() => {
    if (props.LoadDataCallBack) return props.NumRecords ?? 0;
    else return props.Rows ? props.Rows.length : 0;
});
const rowsPerPage: Ref<number> = ref(props.RowsPerPage ?? 20);
log.trace("rowsPerPage:", rowsPerPage.value);
const rowsPerPageInitial = ref(rowsPerPage.value);
const rowStart = computed(() => (page.value - 1) * rowsPerPage.value + 1);
const rowEnd = computed(() => {
    const limit = rowStart.value + rowsPerPage.value - 1;
    const n = numRecords.value ?? 0;
    return n >= limit ? limit : n;
});
const maxPage = computed(() => {
    const n = numRecords.value ?? 0;
    if (n <= 0) return 0;
    let maxP = Math.floor(n / rowsPerPage.value);
    const mod = n % rowsPerPage.value;
    if (mod > 0) maxP++;
    if (maxP < page.value) page.value = maxP;
    return maxP;
});
const pageSwitch = computed(() => {
    let start = page.value - 3; // A dynamic value based on page width
    start = start < 0 ? 0 : start;
    let end = start + 5;
    if (end > maxPage.value) {
        start = maxPage.value - 5;
        end = maxPage.value;
    }
    start = start < 0 ? 0 : start;
    return { start: start, num: end - start };
});
const sortCols = ref(props.DefaultSortCols ?? ([] as number[]));
const sortOrders = ref(getDefaultSortOrder());
function getDefaultSortOrder(): Array<1 | -1> {
    if (props.DefaultSortOrders) {
        if (props.DefaultSortOrders.length === props.DefaultSortCols?.length) {
            return props.DefaultSortOrders;
        }
    }
    return props.DefaultSortCols ?
        Array(props.DefaultSortCols.length).fill(1) :
        [] as Array<1 | -1>;
}
function getSortingKeys() {
    return sortCols.value.flatMap(i => props.Cols[i]);
}
function getSortingOrders() {
    const ordersMapped = sortCols.value.flatMap((colIdx, sortIdx) => {
        const keys = props.Cols[colIdx];
        return (keys instanceof Array) ? keys.map(_ => sortOrders.value[sortIdx]) : sortOrders.value[sortIdx];
    });
    return ordersMapped;
}
// Rows that are displayed
const localRows: ComputedRef<Array<RowWrapper<T>>> = computed(
    () => {
        if (!props.Rows) {
            isLoading.value = true;
            return [];
        }
        let rows = props.Rows.map((row: T) => {
            return { value: row, checked: false } as RowWrapper<T>;
        });
        if (!props.LoadDataCallBack) {
            // Sort locally if there is no callback to get sorted data
            const sortColKeys =
                sortCols.value.length >= 0
                    ? sortCols.value.map((i) => props.Cols[i])
                    : props.ColKey as keyof T
                        ? [props.ColKey as keyof T]
                        : [];

            if (sortColKeys.length > 0) {
                const sortColKeys = getSortingKeys();
                const sortOrders = getSortingOrders();
                rows = rows.sort((a: RowWrapper<any>, b: RowWrapper<any>): number =>
                    Sorter.CompareObjectWithMultipleKeys(
                        a.value,
                        b.value,
                        sortColKeys,
                        sortOrders
                    )
                );
            }
        }
        nextTick(() => {
            isLoading.value = false;
            if (!props.LoadDataCallBack) UpdateTablePosition();
        });
        return rows;
    }
);

const contractRows: Ref<boolean> = ref(false);
// const contractRows: Ref<boolean> = inject("contractRows") ?? ref(false);
const pageRows: ComputedRef<Array<RowWrapper<any>>> = computed(() => {
    if (props.ShowExpand && !contractRows.value) {
        return props.LoadDataCallBack
            ? localRows.value.slice(0, props.ExpansionThreshold)
            : localRows.value.slice(rowStart.value - 1, rowEnd.value).slice(0, props.ExpansionThreshold);
    } else {
        return props.LoadDataCallBack
            ? localRows.value
            : localRows.value.slice(rowStart.value - 1, rowEnd.value);
    }
});
const allRows: ComputedRef<Array<RowWrapper<any>>> = computed(() =>
    props.LoadDataCallBack
        ? localRows.value
        : localRows.value
);
const headerBot = ref(0);
const tableLeft = ref(0);
const tableRight = ref(0);
const tableHeader: Ref<HTMLElement | undefined> = ref(undefined);
__expose<ITableExportsInternal<any>>({
    LoadData: loadDataIfCallBack,
    GetChecked,
    TableLeft: tableLeft,
    TableRight: tableRight,
});

onMounted(() => {
    window.addEventListener("resize", UpdateTablePosition);
    UpdateTablePosition();
    loadDataIfCallBack();
});
onUnmounted(() => window.removeEventListener("resize", UpdateTablePosition));
function onRowClick(row: T) {
    props.RowClickedCallback?.(row);
}
function ExpandRow() {
    log.trace("ExpandRow")
    contractRows.value = !contractRows.value;
}
function UpdateTablePosition() {
    if (!tableHeader.value) return;
    const headerPos = tableHeader.value.getBoundingClientRect();
    headerBot.value = window.scrollY + headerPos.bottom;
    tableLeft.value = window.scrollX + headerPos.left;
    tableRight.value = window.scrollX + headerPos.right;
}
function IsAllChecked(): boolean {
    log.trace("IsAllChecked()");
    if (allRows.value.length == 0) return false;
    else if (allRows.value.length === props.checkCounter) {
        return true;
    }
    else {
        log.trace("IsAllChecked():", false);
        return false;
    }
}
function UpdateCheckedRows(row?: RowWrapper<any>) {
    log.trace("UpdateCheckedRows()")
    props.UpdateCheckedRows!(row, allRows.value);
}
watch(
    () => props.SynchroniseChecksTrigger,
    () => {
        log.trace("Watch()\nSynchroniseChecksTrigger");
        props.SynchroniseChecks?.(allRows.value);
    }
)
watch(
    () => props.CheckedByDefault,
    () => {
        log.trace("Watch()\nCheckedByDefault");
        props.UpdateCheckedRows!(undefined, allRows.value);
    }
)
function UncheckAll() {
    log.trace("UncheckAll()")
    for (const row of allRows.value) {
        if (row.checked) {
            props.CheckRow?.(row);
        }
    }
}
function CheckAll() {
    log.trace("CheckAll()")
    log.trace("allRows:", allRows.value);
    for (const row of allRows.value) {
        if (!row.checked) {
            props.CheckRow?.(row);
        }
    }
}
function CheckUncheckAll() {
    log.trace("CheckUncheckAll()")
    if (IsAllChecked()) {
        UncheckAll();
    } else {
        CheckAll();
    }
}
function GetChecked(): T[] | T[keyof T][] {
    if (props.ReturnKey && props.ColKey) {
        const key = props.ColKey;
        return pageRows.value.filter((a) => a.checked).map((a) => a.value[key]);
    } else return pageRows.value.filter((a) => a.checked).map((a) => a.value);
}
function sortBy(colIndex: number) {
    log.trace("sortBy()");
    const idx = sortCols.value.indexOf(colIndex);
    if (idx >= 0) {
        if (sortOrders.value[idx] < 0) {
            sortCols.value.splice(idx, 1);
            sortOrders.value.splice(idx, 1);
        } else sortOrders.value[idx] = -1;
    } else {
        sortCols.value.unshift(colIndex);
        sortOrders.value.unshift(1);
    }
    log.debug(`sortBy()\nsortCols: ${sortCols.value}\nsortOrders: ${sortOrders.value}`);

    loadDataIfCallBack();

    const oldCheckedRows = props.checkedRows;
    props.checkedRows.length = 0;
    pageRows.value.forEach((row) => {
        if (oldCheckedRows.includes(row.value.InvoiceId)) {
            log.debug(`sortyBy()\ninvoice id: ${row.value.InvoiceId}`);
            props.CheckRow?.(row);
        };
    });
}
function StringFormat(template: string, ...args: any[]) {
    return template.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
}
function updatePage() {
    if (page.value > maxPage.value) page.value = maxPage.value > 0 ? maxPage.value : 1;
}
function clearCallbackRef() {
    callBackPromise = undefined;
}
function loadDataIfCallBack() {
    if (props.LoadDataCallBack) {
        const promise = props.LoadDataCallBack(
            page.value,
            rowsPerPage.value,
            sortCols.value,
            sortOrders.value
        );
        if (callBackPromise) callBackPromise.cancel();
        isLoading.value = true;
        callBackPromise = promise.then(() => {
            updatePage();
            clearCallbackRef();
            UpdateTablePosition();
        }, clearCallbackRef) as CancellablePromise<void>;
    }
}
// changePage event to make sure checkboxes are cleared
function pageChangeCallBack() {
    loadDataIfCallBack();
}
function PrevPage(): boolean {
    const old = page.value;
    if (page.value == 1) return false;
    page.value--;
    pageChangeCallBack();
    return true;
}
function NextPage(): boolean {
    const old = page.value;
    if (page.value >= maxPage.value) return false;
    page.value++;
    pageChangeCallBack();
    return true;
}
function MovePage(p: number) {
    const old = page.value;
    page.value = p;
    pageChangeCallBack();
}
function disabledEventPropagation(event) {
    if (event.stopPropagation) {
        event.stopPropagation();
    } else if (window.event) {
        window.event.cancelBubble = true;
    }
}
function access(item: T, key: keyof T) {
    const v = item[key] as any;
    return (v instanceof Function) ? v.call(item) : v;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", {
          class: "vtl-thead",
          ref_key: "tableHeader",
          ref: tableHeader
        }, [
          _createElementVNode("tr", _hoisted_3, [
            (_ctx.HasCheckBox && _ctx.checkAll)
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "vtl-thead",
                    checked: IsAllChecked(),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (UpdateCheckedRows ? UpdateCheckedRows() : CheckUncheckAll)),
                    title: "Check all rows"
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.checkAll && _ctx.HasCheckBox)
              ? (_openBlock(), _createElementBlock("th", _hoisted_6))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Cols, (col, i) => {
              return (_openBlock(), _createElementBlock("th", {
                class: "vtl-thead",
                key: i
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["vtl-thead-column vtl-sortable vtl-both", {
                                'vtl-asc':
                                    sortCols.value.indexOf(i) >= 0 &&
                                    sortOrders.value[sortCols.value.indexOf(i)] === 1,
                                'vtl-desc':
                                    sortCols.value.indexOf(i) >= 0 &&
                                    sortOrders.value[sortCols.value.indexOf(i)] === -1,
                            }]),
                  onClick: ($event: any) => (sortBy(i as number)),
                  title: `Toggle sort for this column (${_ctx.Labels ? _ctx.Labels![i] ?? col.toString() : ''})`
                }, [
                  (_ctx.Labels && _ctx.Labels.length == _ctx.Cols.length && _ctx.Labels[i])
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: _ctx.Labels[i]
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        title: `Toggle sort for this column (${col.toString()})`
                      }, _toDisplayString(col), 9, _hoisted_9))
                ], 10, _hoisted_7)
              ]))
            }), 128))
          ])
        ], 512),
        _createElementVNode("tr", _hoisted_10, [
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                colspan: _ctx.Cols.length + (_ctx.HasCheckBox ? 1 : 0)
              }, " Loading... ", 8, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        (localRows.value.length > 0 && !_ctx.HideTable)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRows.value, (row, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: _normalizeClass(["vtl-tbody", { 'vtl-checked': _ctx.UnstyledCheckedRows ? false : row.checked, 'vtl-clickable': !!_ctx.RowClickedCallback }]),
                  onClick: ($event: any) => (onRowClick(row.value))
                }, [
                  (_ctx.HasCheckBox)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "vtl-tbody",
                          value: _ctx.ColKey ? row.value[_ctx.ColKey as (keyof any)] : i,
                          checked: row.checked,
                          onChange: ($event: any) => (UpdateCheckedRows ? UpdateCheckedRows(row) : _ctx.CheckRow?.(row)),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (disabledEventPropagation($event))),
                          disabled: _ctx.CheckBoxForAllRows
                            ? false
                            : _ctx.CheckBoxOnRowDefinesNegatives
                                ? row.value[_ctx.CheckBoxOnRow ?? '']
                                : !row.value[_ctx.CheckBoxOnRow ?? '']
                        
                        }, null, 40, _hoisted_15)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Cols, (col, j) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: j,
                      class: _normalizeClass(["vtl-tbody", col]),
                      title: _ctx.RowClickedCallback ? 'Click to view row details (opens new tab)' : ''
                    }, [
                      _renderSlot(_ctx.$slots, (Array.isArray(col)) ? col.join('-') : (col as string), {
                        value: row.value
                      }, () => [
                        (Array.isArray(col))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("span", null, _toDisplayString(col.map((key) => access(row.value, key)).join(" ")), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(access(row.value, col)), 1))
                      ])
                    ], 10, _hoisted_16))
                  }), 128))
                ], 10, _hoisted_13))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", _hoisted_19, [
          (_ctx.ShowExpand)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                colspan: _ctx.Cols.length + (_ctx.HasCheckBox ? 1 : 0),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (ExpandRow()))
              }, _toDisplayString(contractRows.value ? 'Collapse rows...' : 'Expand rows...'), 9, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      (numRecords.value == 0 && !_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.NoDataAvailableMessage), 1))
        : _createCommentVNode("", true)
    ]),
    (maxPage.value > 1 && !_ctx.HideTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(StringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
          ]),
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _unref(page) <= 1 }])
            }, [
              _createElementVNode("div", {
                class: "page-link",
                "aria-label": "Jump to First Page",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (MovePage(1)))
              }, _hoisted_28)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _unref(page) <= 1 }])
            }, [
              _createElementVNode("div", {
                class: "page-link",
                "aria-label": "Previous",
                onClick: PrevPage
              }, _hoisted_31)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSwitch.value.num, (n) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", { active: _unref(page) === n + pageSwitch.value.start }]),
                key: n + pageSwitch.value.start
              }, [
                _createElementVNode("div", {
                  class: "page-link",
                  onClick: ($event: any) => (MovePage(n + pageSwitch.value.start))
                }, _toDisplayString(n + pageSwitch.value.start), 9, _hoisted_32)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _unref(page) >= maxPage.value }])
            }, [
              _createElementVNode("div", {
                class: "page-link",
                "aria-label": "Next",
                onClick: NextPage
              }, _hoisted_35)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _unref(page) >= maxPage.value - 1 }])
            }, [
              _createElementVNode("div", {
                class: "page-link",
                "aria-label": "Next",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (MovePage(maxPage.value)))
              }, _hoisted_38)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.PageSizeChangeLabel), 1),
            _withDirectives(_createElementVNode("select", {
              class: "vtl-paging-select",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rowsPerPage).value = $event)),
              onChange: loadDataIfCallBack
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.PageOptions as Array<number>), (pageOption) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: pageOption,
                  key: pageOption
                }, _toDisplayString(pageOption), 9, _hoisted_41))
              }), 128))
            ], 544), [
              [_vModelSelect, rowsPerPage.value]
            ]),
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.GotoPageLabel), 1),
            _withDirectives(_createElementVNode("select", {
              class: "vtl-paging-select",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (MovePage(_unref(page))))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxPage.value, (n) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_43))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(page)]
            ])
          ])
        ]))
      : (!_ctx.HideTable && numRecords.value > rowsPerPageInitial.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(StringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
            ]),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.PageSizeChangeLabel), 1),
              _withDirectives(_createElementVNode("select", {
                class: "vtl-paging-select",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((rowsPerPage).value = $event)),
                onChange: loadDataIfCallBack
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.PageOptions as Array<number>), (pageOption) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: pageOption,
                    key: pageOption
                  }, _toDisplayString(pageOption), 9, _hoisted_50))
                }), 128))
              ], 544), [
                [_vModelSelect, rowsPerPage.value]
              ]),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.GotoPageLabel), 1),
              _withDirectives(_createElementVNode("select", {
                class: "vtl-paging-select",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (MovePage(_unref(page))))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxPage.value, (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_52))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(page)]
              ])
            ])
          ]))
        : (maxPage.value == 1 && !_ctx.HideTable && _ctx.ShowTableCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, _toDisplayString(StringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode(ScrollToTopButton, {
      visibleY: headerBot.value - scrollOffset
    }, null, 8, ["visibleY"])
  ], 64))
}
}

})